/**
 * The child routes of /settings, generated from the registry: an index
 * redirect to the default section, then one route per entry. App.tsx and
 * the layout test render this same list, so a new section reaches both
 * without a route-table edit.
 */

import { Navigate, Route } from 'react-router-dom'

import { DEFAULT_SETTINGS_SECTION, SETTINGS_SECTIONS } from './sections'
import { SectionRoute } from './SettingsLayout'

export function settingsSectionRoutes(): React.JSX.Element[] {
  return [
    <Route key="index" index element={<Navigate to={DEFAULT_SETTINGS_SECTION.path} replace />} />,
    ...SETTINGS_SECTIONS.map((section) => (
      <Route
        key={section.path}
        path={section.path}
        element={<SectionRoute section={section} />}
      />
    )),
  ]
}
